<template>
  <div class="text-input">

    <label v-if="!!label">{{ label + ( isMandatory ? ' *' : '') }}</label>
    <input
      class="full"
      :type="type"
      :placeholder="placeholder"
      v-model="value"
      v-on:change="onInput"
      v-on:keypress="filterNumber($event)"
      :class="[ isError ? 'error' : '']"
    />
    <span v-if="isError" id="error-message" class="error inline">
      {{ errorMsg }}
    </span>
  </div>
</template>

<script>

import Types from '@/Mapper/CustomType';

export default {
  name: 'TextInput',
  props: {
    label: {
      required: true,
    },
    isMandatory: {
      default: false,
    },
    placeholder: {
      default: '',
    },
    type: {
      default: Types.Input.Text,
    },
    mustMatch: {
      default: '',
    },
    mustNotMatch: {
      default: '',
    },
    default: {
      default: '',
    },
  },
  computed: {
    isError() {
      return this.errorMsg !== '';
    },
    isEmpty() {
      return !this.value || this.value.trim() === '';
    },
    needsEmailFormatting() {
      return this.type === Types.Input.Email;
    },
    needsPhoneFormatting() {
      return this.type === Types.Input.Phone;
    },
    needsToMatch() {
      return this.mustMatchValue !== '';
    },
    needsToNotMatch() {
      return this.mustNotMatchValue !== '';
    },
    valuesObject() {
      return {
        value: this.value,
        error: this.isError,
        label: this.label,
      };
    },
  },
  data() {
    return {
      errorMsg: '',
      value: this.default,
      mustMatchValue: this.mustMatch,
      mustNotMatchValue: this.mustNotMatch,
    };
  },
  created() {
    this.$parent.$on('validate-fields', this.validate);
    this.$parent.$on('reset-inputs', this.resetInputs);
    this.$parent.$on(`${this.label}-set-value`, this.setValue);
  },
  methods: {
    validate(data) {
      this.errorMsg = '';

      if (this.isMissingInput()) {
        this.errorMsg = 'Please enter a value.';
      }

      if (this.needsEmailFormatting && this.hasWrongEmailFormat()) {
        this.errorMsg = 'Please enter a valid email address.';
      }

      if (this.needsPhoneFormatting && this.hasWrongPhoneFormat()) {
        this.errorMsg = 'Please enter a valid phone number (10 digits format).';
      }

      if (this.needsToMatch && this.doesNotMatch()) {
        this.errorMsg = 'Value does not match.';
      }

      if (this.needsToNotMatch && this.matches()) {
        this.errorMsg = 'Current password cannot be same as new.';
      }

      this.$emit('validated-fields', this.valuesObject);
    },
    isMissingInput() {
      return this.isMandatory && this.isEmpty;
    },
    hasWrongEmailFormat() {
      return !this.isEmpty
        && this.$helpers.emailValidation(this.value);
    },
    hasWrongPhoneFormat() {
      return !this.isEmpty
        && (this.value.trim().length !== 10
          || this.$helpers.phoneValidation(this.value));
    },
    doesNotMatch() {
      return !this.isEmpty
        && this.value !== this.mustMatchValue;
    },
    matches() {
      return !this.isEmpty
        && this.value === this.mustNotMatchValue;
    },
    onInput() {
      this.$emit('input', this.valuesObject);
    },
    filterNumber(evt) {
      if (this.needsPhoneFormatting) {
        this.isNumber(evt);
      }
    },
    isNumber(evt) {
      const event = evt || window.event;
      const charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        event.preventDefault();
        return false;
      }
      return true;
    },
    setValue(value, type) {
      switch (type) {
        case Types.Validation.MustMatch:
          this.mustMatchValue = value;
          break;
        case Types.Validation.MustNotMatch:
          this.mustNotMatchValue = value;
          break;
        default:
          this.value = value;
          break;
      }
    },
    resetInputs() {
      this.value = '';
    },
  },
};
</script>

<style lang="scss" scoped>

label {
  @apply ut-font-bold ut-text-sm ut-pb-3 ut-tracking-normal;
  line-height: 24px;
}

.full {
  display: inline-block;
  @apply ut-w-full;
}

.first {
  display: inline-block;
  @apply ut-w-full;
  @screen md {
    width: 58%;
  }
  margin-right: 10px;
}

.second {
  display: inline-block;
  @apply ut-w-full;
  @screen md {
    width: 40%;
  }
}

.half {
  display: inline-block;
  width: 50%;
}

.half.first {
  width: 48%;
  margin-right: 5px;
}

</style>
